// ─────────────────────────────────────────────────────────────────────────────
// Location Emails Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the locationEmails store slice.
// Company-wide selectors are factory selectors (mirror selectCanDo pattern in
// core/store/permissions/permissions.selectors.ts).
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationEmailsState } from './location-emails.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectLocationEmails = createFeatureSelector<LocationEmailsState>('locationEmails');

// ── Company-wide selectors (factory) ─────────────────────────────────────────
// Flat erp/volta lists across every location under a company, fed by the
// LoadCompanyLocationEmails effect; return [] for an unknown customer id.

export const selectLocationEmailsForCompanyErp = (customerId: number) =>
  createSelector(selectLocationEmails, (state) => state.byCustomerId[customerId]?.erp ?? []);

export const selectLocationEmailsForCompanyVolta = (customerId: number) =>
  createSelector(selectLocationEmails, (state) => state.byCustomerId[customerId]?.volta ?? []);

export const selectLocationEmailsLoadingForCompany = (customerId: number) =>
  createSelector(selectLocationEmails, (state) => state.loadingCustomerId === customerId);

// ── Global selectors ─────────────────────────────────────────────────────────

export const selectLocationEmailsLastMutationError = createSelector(selectLocationEmails, (state) => state.lastMutationError);
